import { useCallback, useState } from 'react';

export const useEndDate = () => {
  const [checkoutDate, setEndDate] = useState();
  const setCheckoutDate = useCallback((x) => setEndDate(x), []);
  return { checkoutDate, setCheckoutDate };
};
